var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LexinKeyboardLangContent',{attrs:{"layout_content":_vm.getLayout(),"lang_header":_vm.getHeader()},on:{"add-to-search":_vm.addToSearchInput}})}
var staticRenderFns = []

export { render, staticRenderFns }